import { Component, Input } from '@angular/core';
import { RecipientService } from '../../services/recipient.service';
import { TransferService } from '../../services/transfer.service';
import { Recipient } from '../../models/recipient.model';
import { CryptoRecipient } from '../../models/crypto-recipient';

@Component({
  selector: 'app-create-transfer',
  standalone: false,
  templateUrl: './create-transfer.component.html',
  styleUrl: './create-transfer.component.css'
})
export class CreateTransferComponent {
  @Input() uuid!: string;
  recipientType: 'bank' | 'crypto' = 'bank';

  bankRecipients: Recipient[] = [];
  cryptoRecipients: CryptoRecipient[] = [];

  selectedRecipient: string = '';
  amount: number | null = null;
  note: string = 'Moneco - Return';
  loading = false;
  sending = false;
  errorMessage: string | null = null;

  constructor(
    private recipientService: RecipientService,
    private transferService: TransferService,
  ) {}

  ngOnInit(): void {
    this.loadRecipients();
  }

  loadRecipients() {
    this.loading = true;

    this.recipientService.getRecipients(this.uuid, 1).subscribe({
      next: (res) => {
        this.bankRecipients = res.results;
        this.loading = false;
      },
      error: (err) => {
        console.error('Error loading recipients:', err);
        this.loading = false;
      }
    });

    // Load crypto recipients as well
    this.recipientService.getCryptoRecipients(this.uuid).subscribe({
      next: (res) => {
        this.cryptoRecipients = res.results;
      },
      error: (err) => console.error('Error loading crypto recipients:', err)
    });
  }

  get displayedRecipients() {
    return this.recipientType === 'bank'
      ? this.bankRecipients
      : this.cryptoRecipients;
  }

  sendMoney() {
    if (!this.selectedRecipient || !this.amount) return;

    this.sending = true;
    this.errorMessage = null;

    const payload = {
      transfer_type: this.recipientType === 'bank' ? 'EUR' : 'CRYPTO',
      amount_currency: 'USD',
      recipient_uuid: this.selectedRecipient,
      amount: this.amount,
      note: this.note,
    };

    this.transferService.createTransfer(this.uuid, payload).subscribe({
      next: (res) => {
        console.log(res);
        this.sending = false;
        alert("Transaction has been successfully sent. Check transaction list.");
        window.location.reload();
      },
      error: (err) => {
        console.error('Error creating transfer:', err);
        this.sending = false;
        if (err.error?.message) {
          this.errorMessage = err.error.message;
        } else if (err.error) {
          this.errorMessage = JSON.stringify(err.error);
        } else {
          this.errorMessage = 'An unknown error occurred.';
        }
      }
    });
  }
}
